import {Component, OnInit} from '@angular/core';
import {InventoryControllerService, ProductDto} from '../../../@api';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
    selector: 'app-update-product',
    templateUrl: './update-product.component.html',
    styleUrls: ['./update-product.component.scss']
})
export class UpdateProductComponent implements OnInit {

    product: ProductDto = {};

    constructor(private inventoryControllerService: InventoryControllerService,
                private route: ActivatedRoute,
                private router: Router) {
    }

    async ngOnInit() {
        let snapshot: string[] = this.router.url.split('/');
        let code: string = snapshot[snapshot.length - 1];
        this.product = await this.inventoryControllerService.findProductByCode(code).toPromise();
    }
}
